import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { TagsSelect } from 'fable/tagsSelect/containers/tagsSelect';
export class TagsSelectFieldArray extends PureComponent {
    constructor(props) {
        super(props);
        this.deleteTag = this.deleteTag.bind(this);
        this.addTag = this.addTag.bind(this);
    }
    deleteTag(tag) {
        var _a;
        const { fields } = this.props;
        const index = (_a = fields.getAll()) === null || _a === void 0 ? void 0 : _a.findIndex((t) => t.name === tag.name);
        if (index > -1) {
            fields.remove(index);
        }
    }
    addTag(tag) {
        var _a;
        const { fields } = this.props;
        if (!((_a = fields.getAll()) === null || _a === void 0 ? void 0 : _a.find((t) => t.name === tag.name))) {
            fields.push(tag);
        }
    }
    render() {
        const { fields } = this.props;
        return (_jsx(TagsSelect, { allowCreatingNewTag: true, deselectTag: this.deleteTag, selectTag: this.addTag, selectedItems: fields.getAll() || [], buttonText: "Tags" }));
    }
}
